import React, { useState } from "react";
import "./AboutDoctor.css";
import { Rating } from "react-simple-star-rating";
import AppointmentModal from "../../../common-components/common_modal/appointment_modal/AppointmentModal";
import Green_btn from "../../../common-components/common_btn/green_btn/Green_btn";
import parse from "html-react-parser";

export default function AboutDoctor({ doctor, avg_rating }) {
  const [showModal, setShowModal] = useState(false);

  const formatDoctorTiming = (availabilities = []) => {
    if (!availabilities.length) return "Not Available";

    const formatTime = (time) =>
      new Date(`1970-01-01T${time}`).toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

    const days = availabilities.map((item) => item.day);

    const startTime = formatTime(availabilities[0].start_time);
    const endTime = formatTime(availabilities[0].end_time);

    const weekDays = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    // All 7 days available with same timing
    if (days.length === 7) {
      return `Mon-Sun ${startTime} - ${endTime}`;
    }

    // Consecutive days
    const indexes = days.map((d) => weekDays.indexOf(d)).sort((a, b) => a - b);

    const consecutive = indexes.every(
      (item, index) => index === 0 || item === indexes[index - 1] + 1,
    );

    if (consecutive && days.length > 1) {
      return `${days[0].slice(0, 3)}-${days[days.length - 1].slice(
        0,
        3,
      )} ${startTime} - ${endTime}`;
    }

    // Different timings/days
    return availabilities
      .map(
        (item) =>
          `${item.day.slice(0, 3)} ${formatTime(
            item.start_time,
          )} - ${formatTime(item.end_time)}`,
      )
      .join(", ");
  };

  return (
    <div className="doctor_profile_card">
      <div className="doctor_profile_wrapper container">
        <div className="doctor_profile_left">
          <img
            alt={doctor?.name}
            src={
              doctor?.image
                ? `${process.env.REACT_APP_IMG_URL}${doctor.image}`
                : "/assets/images/home/dr/img1.png"
            }
            className="doctor_profile_img"
          />
        </div>

        <div className="doctor_profile_right">
          <div className="doctor_top_section">
            <div className="doctor_name_rating">
              <h2 className="doctor_profile_name">
                {doctor?.Doctor_Detail?.doctor_code || ""}. {doctor?.name || ""}
              </h2>

              <div className="doctor_rating_wrapper">
                <Rating
                  // initialValue={5}
                  initialValue={Number(avg_rating?.average_rating)}
                  readonly
                  size={18}
                  allowFraction
                />
                <span className="doctor_review_text">
                  ({avg_rating?.total_counts} Reviews)
                </span>
              </div>
            </div>

            <div className="doctor_info_row">
              <span className="doctor_specialist_text">
                {doctor?.Doctor_Detail?.Specialization?.name || ""} ({" "}
                {doctor?.Doctor_Detail?.degree || ""})
              </span>

              <span className="doctor_experience_text">
                {doctor?.Doctor_Detail?.expirence || ""}+ Years Experience
              </span>
            </div>

            <div className="doctor_info_row">
              <span className="doctor_hospital_text">
                {doctor?.Doctor_Detail?.hospital_name || ""}
              </span>

              {/* <span className="doctor_time_text">
                Mon-Sun &nbsp; 09:30 AM - 07:45 PM
              </span> */}

              {/* <span className="doctor_time_text">
                {formatDoctorTiming(
                  doctor?.Doctor_Detail?.Doctor_Availabilities,
                )}
              </span> */}
            </div>

            <p className="doctor_description_text">
              {" "}
              {parse(doctor?.Doctor_Detail?.description || "")}
            </p>
          </div>

          <div className="doctor_bottom_section row">
            <div className="doctor_box_card col-md-6">
              <h4 className="doctor_box_title">Specializations</h4>
              {/* <div className="doctor_card">
                {parse(doctor?.Doctor_Detail?.specialization || "")}
              </div> */}
              <div className="doctor_card">
                <ul>
                  {(doctor?.Doctor_Detail?.specialization || "")
                    .replace(/<[^>]*>/g, "")
                    .split(/\r?\n|,/)
                    .map((item, index) => {
                      const text = item.trim();

                      if (!text) return null;

                      return <li key={index}>{text}</li>;
                    })}
                </ul>
              </div>
            </div>

            <div className="doctor_box_card col-md-6">
              <h4 className="doctor_box_title">Education & Qualifications</h4>
              {/* <div className="doctor_card">
                {parse(doctor?.Doctor_Detail?.education_qualifications || "")}
              </div> */}
              <div className="doctor_card">
                <ul>
                  {(doctor?.Doctor_Detail?.education_qualifications || "")
                    .replace(/<[^>]*>/g, "")
                    .split(/\r?\n|,/)
                    .map((item, index) => {
                      const text = item.trim();

                      if (!text) return null;

                      return <li key={index}>{text}</li>;
                    })}
                </ul>
              </div>
            </div>
          </div>

          <div className="doctor_book_btn">
            <Green_btn
              btnText="Book Appointment Now"
              onClick={() => setShowModal(true)}
            />
          </div>
        </div>
      </div>
      <AppointmentModal
        doctor={doctor}
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </div>
  );
}
